// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IPageableObject } from './IPageableObject';
import {
    IPageableObjectFromJSON,
    IPageableObjectFromJSONTyped,
    IPageableObjectToJSON,
    IPageableObjectToJSONTyped,
} from './IPageableObject';
import type { ILedgerReportDto } from './ILedgerReportDto';
import {
    ILedgerReportDtoFromJSON,
    ILedgerReportDtoFromJSONTyped,
    ILedgerReportDtoToJSON,
    ILedgerReportDtoToJSONTyped,
} from './ILedgerReportDto';
import type { ISortOrder } from './ISortOrder';
import {
    ISortOrderFromJSON,
    ISortOrderFromJSONTyped,
    ISortOrderToJSON,
    ISortOrderToJSONTyped,
} from './ISortOrder';

/**
 * 
 * @export
 * @interface IPageLedgerReportDto
 */
export interface IPageLedgerReportDto {
    /**
     * 
     * @type {number}
     * @memberof IPageLedgerReportDto
     */
    total_pages?: number;
    /**
     * 
     * @type {number}
     * @memberof IPageLedgerReportDto
     */
    total_elements?: number;
    /**
     * 
     * @type {number}
     * @memberof IPageLedgerReportDto
     */
    size?: number;
    /**
     * 
     * @type {Array<ILedgerReportDto>}
     * @memberof IPageLedgerReportDto
     */
    content?: Array<ILedgerReportDto>;
    /**
     * 
     * @type {number}
     * @memberof IPageLedgerReportDto
     */
    number?: number;
    /**
     * 
     * @type {Array<ISortOrder>}
     * @memberof IPageLedgerReportDto
     */
    sort?: Array<ISortOrder>;
    /**
     * 
     * @type {IPageableObject}
     * @memberof IPageLedgerReportDto
     */
    pageable?: IPageableObject;
    /**
     * 
     * @type {number}
     * @memberof IPageLedgerReportDto
     */
    number_of_elements?: number;
    /**
     * 
     * @type {boolean}
     * @memberof IPageLedgerReportDto
     */
    first?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IPageLedgerReportDto
     */
    last?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IPageLedgerReportDto
     */
    empty?: boolean;
}

/**
 * Check if a given object implements the IPageLedgerReportDto interface.
 */
export function instanceOfIPageLedgerReportDto(value: object): value is IPageLedgerReportDto {
    return true;
}

export function IPageLedgerReportDtoFromJSON(json: any): IPageLedgerReportDto {
    return IPageLedgerReportDtoFromJSONTyped(json, false);
}

export function IPageLedgerReportDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IPageLedgerReportDto {
    if (json == null) {
        return json;
    }
    return {
        
        'total_pages': json['totalPages'] == null ? undefined : json['totalPages'],
        'total_elements': json['totalElements'] == null ? undefined : json['totalElements'],
        'size': json['size'] == null ? undefined : json['size'],
        'content': json['content'] == null ? undefined : ((json['content'] as Array<any>).map(ILedgerReportDtoFromJSON)),
        'number': json['number'] == null ? undefined : json['number'],
        'sort': json['sort'] == null ? undefined : ((json['sort'] as Array<any>).map(ISortOrderFromJSON)),
        'pageable': json['pageable'] == null ? undefined : IPageableObjectFromJSON(json['pageable']),
        'number_of_elements': json['numberOfElements'] == null ? undefined : json['numberOfElements'],
        'first': json['first'] == null ? undefined : json['first'],
        'last': json['last'] == null ? undefined : json['last'],
        'empty': json['empty'] == null ? undefined : json['empty'],
    };
}

export function IPageLedgerReportDtoToJSON(json: any): IPageLedgerReportDto {
    return IPageLedgerReportDtoToJSONTyped(json, false);
}

export function IPageLedgerReportDtoToJSONTyped(value?: IPageLedgerReportDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'totalPages': value['total_pages'],
        'totalElements': value['total_elements'],
        'size': value['size'],
        'content': value['content'] == null ? undefined : ((value['content'] as Array<any>).map(ILedgerReportDtoToJSON)),
        'number': value['number'],
        'sort': value['sort'] == null ? undefined : ((value['sort'] as Array<any>).map(ISortOrderToJSON)),
        'pageable': IPageableObjectToJSON(value['pageable']),
        'numberOfElements': value['number_of_elements'],
        'first': value['first'],
        'last': value['last'],
        'empty': value['empty'],
    };
}

